import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'assess-auditing-notes',
  templateUrl: './auditing-notes.component.html',
  styleUrls: ['./auditing-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditingNotesComponent {
  @Input()
  notes?: string;
}
